var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h100-60 noPage"},[_c('ejs-grid',{ref:"grid",attrs:{"height":"calc(100% - 80px)","rowSelected":_vm.watchRowSelected,"rowDeselected":_vm.watchRowDeSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }